import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <span className="logo-icon">🔧</span>
          <div className="logo-text">
            <span className="logo-name">СЕТЬМОНТАЖ</span>
            <span className="logo-tagline">IT-решения с 2011 года</span>
          </div>
        </Link>

        {/* Mobile menu toggle */}
        <button 
          className="navbar-toggle" 
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={menuOpen ? 'bar active' : 'bar'}></span>
          <span className={menuOpen ? 'bar active' : 'bar'}></span>
          <span className={menuOpen ? 'bar active' : 'bar'}></span>
        </button>

        {/* Navigation Links */}
        <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
          <Link to="/" className="nav-link" onClick={() => setMenuOpen(false)}>
            Главная
          </Link>

          {/* Services Dropdown */}
          <div 
            className="nav-dropdown"
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <button
              type="button"
              className="nav-link dropdown-trigger"
              onClick={() => setServicesOpen(!servicesOpen)}
              aria-expanded={servicesOpen}
            >
              Услуги <span className={`dropdown-arrow ${servicesOpen ? 'open' : ''}`}>▼</span>
            </button>
            {servicesOpen && (
              <div className="dropdown-menu">
                <Link to="/services/hotel" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  🏨 Гостиничные решения
                </Link>
                <Link to="/services/networks" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  🌐 Сети и коммуникации
                </Link>
                <Link to="/services/automation" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  🏠 Автоматизация
                </Link>
                <Link to="/services/video" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  📹 Видеонаблюдение
                </Link>
                <Link to="/services/wifi" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  📶 Wi-Fi и HotSpot
                </Link>
                <Link to="/services/telephony" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  📞 Телефония
                </Link>
                <Link to="/services/tv" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  📺 Телевидение
                </Link>
                <Link to="/services/servers" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  🖥️ Серверные комнаты
                </Link>
                <Link to="/services/barrier" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  🚧 Умный шлагбаум
                </Link>
                <Link to="/services/access" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  🔐 Контроль доступа
                </Link>
                <Link to="/services/workplaces" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  💼 Рабочие места
                </Link>
                <Link to="/services/equipment" className="dropdown-item" onClick={() => { setMenuOpen(false); setServicesOpen(false); }}>
                  ⚙️ Подбор оборудования
                </Link>
              </div>
            )}
          </div>

          <Link to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>
            15 лет опыта
          </Link>
          <Link to="/contact" className="nav-link" onClick={() => setMenuOpen(false)}>
            Контакты
          </Link>

          {/* Auth Links */}
          {user ? (
            <>
              <Link to="/dashboard" className="nav-link nav-highlight" onClick={() => setMenuOpen(false)}>
                Панель
              </Link>
              <button onClick={() => { handleLogout(); setMenuOpen(false); }} className="nav-link nav-btn">
                Выход
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link" onClick={() => setMenuOpen(false)}>
                Вход
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
